import { useMemo } from 'react'

import useFarwestTimeInterval, {
  IDataType as IFarwestTimeIntervalDataType,
} from './useFarwestTimeinterval'
import useFarwestFinancialCheckAverageCharts, {
  IDataType as IFarwestFinancialCheckAverageChartsDataType,
} from './useFinancialCheckAverageCharts'
import useFarwestFinancialSalesCharts, {
  IDataType as IFarwestFinancialSalesChartsDataType,
} from './useFinancialSalesCharts'
import useFinancialSssCharts, {
  IDataType as IFinancialSssChartsDataType,
} from './useFinancialSssCharts'
import useFwWingstopConstants, {
  IDataType as IFwWingstopConstantsDataType,
} from './useFwWingstopConstants'
import useFwWingstopProductMixItems, {
  IDataType as IFwWingstopProductMixItems,
} from './useFwWingstopProductMixItems'
import useLocationIntradayConfigs, {
  IDataType as ILocationIntradayConfigsDataType,
} from './useLocationIntradayConfigs'
import useNormalizeStatusType, {
  IDataType as INormalizeStatusDataType,
  IOptionType as INormalizeStatusOptionType,
} from './useNormalizeStatusType'
import useFwWingstopRevenueCenterSales, {
  IDataType as IFwWingstopRevenueCenterSalesDateType,
} from './useRevenueCenterSales'
import useUploadReport, {
  IDataType as IUploadReportDataType,
} from './useUploadReport'

interface ITrendDataType {
  isTrend?: true
}

export type IVariablesType =
  | 'trend'
  | 'farwestTimeinterval'
  | 'farwestFinancialSalesCharts'
  | 'farwestFinancialCheckAverageCharts'
  | 'farwestFinancialSssCharts'
  | 'farwestUploadReport'
  | 'farwestLocationIntradayConfigs'
  | ({ type: 'farwestNormalizeStatus' } & INormalizeStatusOptionType)
  | 'fwWingstopRevenueCenterSales'
  | 'fwWingstopConstants'
  | 'fwWingstopProductMixItems'

export type IDataType = ITrendDataType &
  IFarwestTimeIntervalDataType &
  IFarwestFinancialSalesChartsDataType &
  IFarwestFinancialCheckAverageChartsDataType &
  IFinancialSssChartsDataType &
  IUploadReportDataType &
  ILocationIntradayConfigsDataType &
  INormalizeStatusDataType &
  IFwWingstopRevenueCenterSalesDateType &
  IFwWingstopConstantsDataType &
  IFwWingstopProductMixItems

const useTrend = (): ITrendDataType =>
  useMemo(
    () => ({
      isTrend: true,
    }),
    [],
  )

export const hooks = [
  ['trend', useTrend],
  ['farwestTimeinterval', useFarwestTimeInterval],
  ['farwestFinancialSalesCharts', useFarwestFinancialSalesCharts],
  ['farwestFinancialCheckAverageCharts', useFarwestFinancialCheckAverageCharts],
  ['farwestFinancialSssCharts', useFinancialSssCharts],
  ['farwestUploadReport', useUploadReport],
  ['farwestLocationIntradayConfigs', useLocationIntradayConfigs],
  ['farwestNormalizeStatus', useNormalizeStatusType],
  ['fwWingstopRevenueCenterSales', useFwWingstopRevenueCenterSales],
  ['fwWingstopConstants', useFwWingstopConstants],
  ['fwWingstopProductMixItems', useFwWingstopProductMixItems],
] as const
